import React, { useEffect, useState } from "react";

import apiClient from "../../../services/apiClient";
import { openMonthlySummary } from "./monthlySummaryOpen";

// 로그인 뒤 첫 화면에 한 번 띄우는 월간 결산 안내.
//
// 학원관리 탭에도 입구가 있지만 거기까지 들어오는 원장이 많지 않다. 달마다 한 번만
// 띄우고, 닫으면 그 달에는 다시 뜨지 않는다(브라우저에 표시를 남긴다).
//
// **다른 팝업보다 먼저 나온다.** 이것을 처리하기 전에는 체험 안내가 뜨지 않게
// `onResolved` 로 알려 준다. 두 개가 겹쳐 뜨면 둘 다 안 읽고 닫는다.
// 그래서 바깥을 눌러도 닫히지 않고, 여는 단추와 작은 닫기만 남겼다.
const seenKey = (month) => `monthly_summary_seen_${month}`;

const MonthlySummaryPopup = ({ onResolved }) => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let done = false;
    const finish = () => {
      if (!done) {
        done = true;
        if (onResolved) onResolved();
      }
    };

    apiClient
      .get("/api/v1/echo/monthly-summary/mine", { withAuth: true })
      .then((response) => {
        const data = response.data;
        if (!data.ready) return finish();
        // 한 번 열어 본 학원에는 다시 띄우지 않는다. 서버가 열람을 기억하므로
        // 기기를 바꿔도 따라온다. 브라우저 표시는 '닫기' 만 기억한다.
        if (data.opened) return finish();
        if (window.localStorage.getItem(seenKey(data.month))) return finish();
        setSummary(data);
      })
      .catch(finish);
  }, [onResolved]);

  if (!summary) return null;

  const close = () => {
    try {
      window.localStorage.setItem(seenKey(summary.month), "1");
    } catch (e) {
      // 사파리 비공개 모드에서는 저장이 막힌다. 닫히기만 하면 된다.
    }
    setSummary(null);
    if (onResolved) onResolved();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(14,20,27,.55)",
        zIndex: 900,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "18px",
      }}
    >
      <div
        style={{
          background: "#fff",
          maxWidth: "380px",
          width: "100%",
          overflow: "hidden",
          boxShadow: "0 30px 70px -30px rgba(10,30,35,.6)",
        }}
      >
        <div
          style={{
            background: "#0E141B",
            color: "#fff",
            padding: "20px 22px 18px",
            position: "relative",
          }}
        >
          <button
            type="button"
            aria-label="닫기"
            onClick={close}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              background: "none",
              border: "none",
              color: "#6d7d7b",
              fontSize: "18px",
              lineHeight: 1,
              cursor: "pointer",
              padding: "4px 6px",
            }}
          >
            ×
          </button>
          <div
            style={{
              fontSize: "11px",
              fontWeight: 800,
              letterSpacing: ".1em",
              color: "#00D9C0",
              marginBottom: "8px",
            }}
          >
            지인에듀 온라인
          </div>
          <div style={{ fontSize: "20px", fontWeight: 800, lineHeight: 1.4 }}>
            {summary.month_label} 학습 진단
            <br />
            보고서가 나왔습니다
          </div>
        </div>
        <div style={{ padding: "18px 22px 22px" }}>
          <div style={{ fontSize: "14px", color: "#5b666f", lineHeight: 1.65 }}>
            다른 학원과 견준 우리 학원의 자리, 아이별 현황, 다음 달에 바꾸면
            좋을 것 세 가지를 정리했습니다.
          </div>
          <button
            type="button"
            onClick={() => {
              openMonthlySummary({
                month: summary.month,
                title: `${summary.month_label} 학습 진단`,
              });
              close();
            }}
            style={{
              display: "block",
              width: "100%",
              border: "none",
              cursor: "pointer",
              marginTop: "16px",
              background: "#00A396",
              color: "#fff",
              fontWeight: 800,
              fontSize: "15px",
              padding: "13px 0",
              textAlign: "center",
              textDecoration: "none",
            }}
          >
            보고서 열기
          </button>
          <div
            style={{
              marginTop: "10px",
              fontSize: "12px",
              color: "#8a949c",
              textAlign: "center",
            }}
          >
            학원관리 탭에서 언제든 다시 볼 수 있습니다
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlySummaryPopup;
